import { WHITE, GRECIAN_GREY } from "../../../constants/colors";

const backgroundColor = WHITE;
const iconBackgroundColor = GRECIAN_GREY;

export const fallbackValues = {
  backgroundColor,
  iconBackgroundColor
};
